import {
    PLAN_SUBMIT_PLAN_LNG_BEGIN,
    PLAN_SUBMIT_PLAN_LNG_SUCCESS,
    PLAN_SUBMIT_PLAN_LNG_FAILURE,
    PLAN_SUBMIT_PLAN_LNG_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitPlan_lng(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: PLAN_SUBMIT_PLAN_LNG_BEGIN,
      });

    const promise = new Promise((resolve, reject) => {
        request({
          url:'/api/gc/batch/lng',
          method:params.id !== undefined ? 'put' :'post',
          // method:'post',
          data: params,
        }).then( data => {
            dispatch({
                type: PLAN_SUBMIT_PLAN_LNG_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: PLAN_SUBMIT_PLAN_LNG_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitPlan_lngError() {
    return {
      type: PLAN_SUBMIT_PLAN_LNG_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PLAN_SUBMIT_PLAN_LNG_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitPlan_lngPending: true,
          submitPlan_lngError: null,
        };
  
      case PLAN_SUBMIT_PLAN_LNG_SUCCESS:
        // The request is success
        return {
          ...state,
          submitPlan_lngPending: false,
          submitPlan_lngError: null,
        };
  
      case PLAN_SUBMIT_PLAN_LNG_FAILURE:
        // The request is failed
        return {
          ...state,
          submitPlan_lngPending: false,
          submitPlan_lngError: action.data.error,
        };
  
      case PLAN_SUBMIT_PLAN_LNG_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitPlan_lngError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/plan/redux/submitPlan_lng.js